import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import Cookies from 'js-cookie'
import API_BASE_URL from '../../../../config/api'
import Topbar from '../../mini-comp/Topbar'
import Sidebar from '../../mini-comp/Sidebar'
import {
    RiMoneyDollarCircleLine,
    RiBankCardLine,
    RiLoader4Line,
    RiPrinterLine,
    RiDownloadLine,
    RiMailSendLine,
    RiArrowLeftLine
} from 'react-icons/ri'

const PayslipDetail = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [payslip, setPayslip] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        const fetchPayslip = async () => {
            setLoading(true)
            try {
                const token = Cookies.get('token')
                const res = await axios.get(`${API_BASE_URL}/api/v1/payroll/payslip/${id}/`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                })
                console.log(res.data)
                setPayslip(res.data)
            } catch (err) {
                console.error("Error fetching payslip detail:", err)
                setError("Failed to load payslip details.")
            } finally {
                setLoading(false)
            }
        }
        fetchPayslip()
    }, [id])

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount || 0)
    }

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
    }

    if (loading) return (
        <div>
            <Topbar /> <Sidebar />
            <div className="app-content-area">
                <div className="app-content-wrap">
                    <div className="container-fluid d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
                        <RiLoader4Line className="spinner-border text-primary fs-1 mb-3" style={{ border: 'none', animation: 'spin 1s linear infinite' }} />
                        <p className="text-muted">Loading Payslip...</p>
                    </div>
                </div>
            </div>
            <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
        </div>
    )

    if (error) return (
        <div>
            <Topbar /> <Sidebar />
            <div className="app-content-area py-5 text-center">
                <div className="alert alert-danger mx-auto" style={{ maxWidth: '500px' }}>{error}</div>
                <button className="btn btn-primary" onClick={() => navigate(-1)}>Back</button>
            </div>
        </div>
    )

    return (
        <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
            <Topbar />
            <Sidebar />
            <div className="app-content-area">
                <div className="app-content-wrap">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card border-0 shadow-lg">
                                    <div className="card-body p-5">
                                        <div className="payslip-wrapper position-relative">
                                            <div className="watermark opacity-25" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%) rotate(-45deg)', fontSize: '100px', fontWeight: 'bold', color: '#f0f0f0', pointerEvents: 'none', zIndex: 0 }}>
                                                PAYSLIP
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mb-5" style={{ position: 'relative', zIndex: 1 }}>
                                                <div>
                                                    <h2 className="fw-bold mb-0">Payslip</h2>
                                                    <p className="text-muted">Period: {formatDate(payslip?.generated_on)}</p>
                                                </div>
                                                <div className="text-end">
                                                    <button className="btn btn-outline-secondary btn-sm d-flex-items gap-5" onClick={() => navigate(-1)}>
                                                        <RiArrowLeftLine /> Back
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Employee & Payment Information */}
                                            <div className="row g-4 mb-5" style={{ position: 'relative', zIndex: 1 }}>
                                                <div className="col-md-6">
                                                    <div className="card bg-light-subtle border-0 h-100">
                                                        <div className="card-body">
                                                            <h5 className="fw-bold mb-4 d-flex align-items-center gap-2">
                                                                <RiMoneyDollarCircleLine className="text-primary" /> Employee Details
                                                            </h5>
                                                            <div className="d-flex flex-column gap-2 fs-14">
                                                                <div className="d-flex justify-content-between">
                                                                    <span className="text-muted">Employee ID:</span>
                                                                    <span className="fw-bold">{payslip?.employee_data?.employee_id || payslip?.employee?.employee_id}</span>
                                                                </div>
                                                                <div className="d-flex justify-content-between">
                                                                    <span className="text-muted">Surname:</span>
                                                                    <span className="fw-bold">{payslip?.employee_data?.last_name || payslip?.employee?.full_name}</span>
                                                                </div>
                                                                <div className="d-flex justify-content-between">
                                                                    <span className="text-muted">First Name:</span>
                                                                    <span className="fw-bold">{payslip?.employee_data?.first_name || payslip?.employee?.full_name}</span>
                                                                </div>
                                                                <div className="d-flex justify-content-between">
                                                                    <span className="text-muted">Department:</span>
                                                                    <span className="fw-bold">{payslip?.employee_data?.department || payslip?.employee?.department?.name || 'N/A'}</span>
                                                                </div>
                                                                <div className="d-flex justify-content-between">
                                                                    <span className="text-muted">Position:</span>
                                                                    <span className="fw-bold">{payslip?.employee_data?.position || payslip?.employee?.position || 'N/A'}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="card bg-light-subtle border-0 h-100">
                                                        <div className="card-body">
                                                            <h5 className="fw-bold mb-4 d-flex align-items-center gap-2">
                                                                <RiBankCardLine className="text-success" /> Payment Information
                                                            </h5>
                                                            <div className="d-flex flex-column gap-2 fs-14">
                                                                <div className="d-flex justify-content-between">
                                                                    <span className="text-muted">Bank Name:</span>
                                                                    <span className="fw-bold">{payslip?.employee_data?.bank_name || 'N/A'}</span>
                                                                </div>
                                                                <div className="d-flex justify-content-between">
                                                                    <span className="text-muted">Branch:</span>
                                                                    <span className="fw-bold">{payslip?.employee_data?.bank_branch || 'USD'}</span>
                                                                </div>
                                                                <div className="d-flex justify-content-between">
                                                                    <span className="text-muted">Account Number:</span>
                                                                    <span className="fw-bold">{payslip?.employee_data?.bank_account_number || 'N/A'}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Earnings & Deductions Tables */}
                                            <div className="row g-4 mb-5" style={{ position: 'relative', zIndex: 1 }}>
                                                <div className="col-md-6">
                                                    <h5 className="fw-bold mb-3">Earnings</h5>
                                                    <table className="table table-hover border fs-14">
                                                        <thead className="bg-light-subtle">
                                                            <tr>
                                                                <th>Description</th>
                                                                <th className="text-end">Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>Basic Salary</td>
                                                                <td className="text-end">{formatCurrency(payslip?.employee_data?.basic_salary)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Earned Salary</td>
                                                                <td className="text-end">{formatCurrency(payslip?.earned_salary)}</td>
                                                            </tr>
                                                            {payslip?.allowance_data?.map((item, idx) => (
                                                                <tr key={idx}>
                                                                    <td>{item.title}</td>
                                                                    <td className="text-end">{formatCurrency(item.amount)}</td>
                                                                </tr>
                                                            ))}
                                                            {payslip.overtime_1_5 && payslip.overtime_1_5 >0?
                                                            <tr>
                                                                <td>Overtime(1.5x)</td>
                                                                <td className="text-end">{formatCurrency(payslip?.overtime_1_5)}</td>
                                                            </tr> : ''
                                                            }
                                                            {payslip.overtime_2_0 && payslip.overtime_2_0 >0?
                                                            <tr>
                                                                <td>Overtime(2.0x)</td>
                                                                <td className="text-end">{formatCurrency(payslip?.overtime_2_0)}</td>
                                                            </tr> : ''
                                                            }
                                                            {payslip.cill && payslip.cill >0?
                                                            <tr>
                                                                <td>CILL</td>
                                                                <td className="text-end">{formatCurrency(payslip?.cill)}</td>
                                                            </tr> : ''
                                                            }
                                                        </tbody>
                                                        <tfoot className="bg-light-subtle fw-bold">
                                                            <tr>
                                                                <td>Total Earnings</td>
                                                                <td className="text-end text-primary">{formatCurrency((parseFloat(payslip?.earned_salary) || 0) + (parseFloat(payslip?.total_allowances) || 0)+ (parseFloat(payslip?.overtime_1_5) || 0)+ (parseFloat(payslip?.overtime_2_0) || 0) + (parseFloat(payslip?.cill) || 0))}</td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                    {/* Net Pay Summary */}
                                                    <div className="row mb-5 mt-4" style={{ position: 'relative', zIndex: 1 }}>
                                                        <div className="col-md-12">
                                                            <div className="card shadow-sm border-0 bg-primary-subtle text-primary p-4 text-end">
                                                                <h6 className="mb-1 text-muted">NET SALARY</h6>
                                                                <h1 className="fw-bold mb-2">{formatCurrency(payslip?.net_salary)}</h1>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <h5 className="fw-bold mb-3">Deductions</h5>
                                                    <table className="table table-hover border fs-14">
                                                        <thead className="bg-light-subtle">
                                                            <tr>
                                                                <th>Description</th>
                                                                <th className="text-end">Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>NSSA</td>
                                                                <td className="text-end">{formatCurrency(payslip?.nssa)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Paye</td>
                                                                <td className="text-end">{formatCurrency(payslip?.paye)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>NEC</td>
                                                                <td className="text-end">{formatCurrency(payslip?.nec)}</td>
                                                            </tr>
                                                            
                                                            <tr>
                                                                <td>AIDS Levy</td>
                                                                <td className="text-end">{formatCurrency(payslip?.aids_levy)}</td>
                                                            </tr>
                                                            {payslip?.deduction_data?.length === 0 ? (
                                                                <tr>
                                                                    <td colSpan="2" className="text-center text-muted py-3"></td>
                                                                </tr>
                                                            ) : (
                                                                payslip?.deduction_data?.map((item, idx) => (
                                                                    <tr key={idx}>
                                                                        <td>{item.title}</td>
                                                                        <td className="text-end">{item.deduction_type === 'one_time' ? formatCurrency(item.amount) : formatCurrency(item.monthly_deduction)}</td>
                                                                    </tr>
                                                                ))
                                                            )}
                                                        </tbody>
                                                        <tfoot className="bg-light-subtle fw-bold">
                                                            <tr>
                                                                <td>Total Deductions</td>
                                                                <td className="text-end text-danger">{formatCurrency(payslip?.total_deductions)}</td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </div>



                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <style>{`
                .card { transition: all 0.3s ease; }
                .watermark { opacity: 0.05 !important; }
                .bg-light-subtle { background-color: rgba(248, 249, 250, 0.5) !important; }
                .bg-primary-subtle { background-color: rgba(13, 110, 253, 0.1) !important; }
                .fs-14 { font-size: 14px; }
            `}</style>
        </div>
    )
}

export default PayslipDetail
